import { useMutation, useQueryClient } from '@tanstack/react-query';

import { putSpotQuoteCollaborator } from '@/redux/common/CommonEffects';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

export const usePutQuoteCollaborators = ({ spotQuoteId }: { spotQuoteId: number }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: putSpotQuoteCollaborator,
    onError: (error) => {
      showNotification({
        message: error.message || 'Failed to save quote collaborators',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['quote-collaborators-list', spotQuoteId],
      });
    },
  });
};
